/* eslint-disable react-hooks/rules-of-hooks */
import { AttributeIdentifiers } from "@lyfegen-platform/graphql-schema/models";
import { useFieldValue, useSetFieldValue } from "formik";
import { useEffect, useRef } from "react";
import * as Yup from "yup";
import { useAvailableTreatments } from "../hooks/useAvailableTreatments";
import { FlexControlProps } from "../models/flexible/flex-field-controller";
import { combinePaths } from "../models/flexible/utils";
import { Treatment } from "../models/generated/graphql";
import { getPathPrefix } from "../utils/get-path-prefix";
import { GeneralFieldController } from "./general-field-controller";

const SetRefAndLotEffect: React.FC<{ path: string }> = ({ path }) => {
	const [supportingItem] = useFieldValue(path) as Array<Treatment>;
	const setFieldValue = useSetFieldValue();
	const code = supportingItem?.UDI || "";
	const ref = useRef(code);

	useEffect(() => {
		if (ref.current !== code) {
			ref.current = code;
			setFieldValue(combinePaths(getPathPrefix(path, 1), AttributeIdentifiers.SupportingItemRef), supportingItem?.REF || "");
			setFieldValue(combinePaths(getPathPrefix(path, 1), AttributeIdentifiers.SupportingItemLot), supportingItem?.LOT || "");
		}
	}, [code, path, setFieldValue, supportingItem?.LOT, supportingItem?.REF]);

	return null;
};

export class SupportingItemModelFieldController extends GeneralFieldController {
	protected override createFieldValidationRuleByDataType(): Yup.AnySchema {
		return Yup.object().nullable();
	}

	override useControlProps(path: string): FlexControlProps {
		const [currentTreatment] = useFieldValue(path);
		const selectedItems = useFieldValue(getPathPrefix(path, 2)) as Array<{ [AttributeIdentifiers.SupportingItemModel]: Treatment }>;
		const treatments = useAvailableTreatments(this.parent);
		const supportingTreatments = treatments.filter(
			(treatment) =>
				!treatment.canBeMain &&
				(treatment.UDI === currentTreatment?.UDI || selectedItems.every((item) => item.supportingItemModel?.UDI !== treatment.UDI))
		);

		return {
			controlType: "typeahead",
			optionLabel: "Name",
			property: "Code",
			options: supportingTreatments,
		};
	}

	override getValueTypeProps() {
		return {
			controlType: "typeahead",
			property: "Name",
		};
	}

	renderBeforeContent(path: string): React.ReactElement {
		return <SetRefAndLotEffect path={path} />;
	}
}
